import { useState } from "react";

const navLinks = [
  { label: "今日热榜", href: "#hot" },
  { label: "最新吃瓜", href: "#latest" },
  { label: "话题广场", href: "#topics" },
  { label: "吃瓜讨论区", href: "#community" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/70 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:h-[72px] md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-fill w-5 h-5 flex items-center justify-center text-base" />
          </span>
          <span className="flex items-baseline gap-1.5">
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
              黑料免费
            </span>
            <span className="rounded-sm bg-accent-100 px-1.5 py-0.5 text-[10px] font-semibold text-accent-700">
              零成本
            </span>
          </span>
        </a>

        <nav className="ml-4 hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto hidden items-center gap-3 md:flex">
          <div className="flex h-10 w-56 items-center gap-2 rounded-full border border-background-200 bg-background-100 px-4 text-foreground-500 transition-colors focus-within:border-primary-300 focus-within:bg-background-50">
            <i className="ri-search-line w-4 h-4 flex items-center justify-center text-sm" />
            <input
              type="text"
              placeholder="搜热榜 / 话题 / 剧名"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>
          <a
            href="#hot"
            className="inline-flex h-10 shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-play-fill w-4 h-4 flex items-center justify-center text-sm" />
            开始吃瓜
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((prev) => !prev)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 pb-5 pt-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
          </div>
          <div className="mt-3 flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-4 py-2.5 text-foreground-500">
            <i className="ri-search-line w-4 h-4 flex items-center justify-center text-sm" />
            <input
              type="text"
              placeholder="搜热榜 / 话题 / 剧名"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>
          <a
            href="#hot"
            onClick={() => setMenuOpen(false)}
            className="mt-3 flex h-11 w-full items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 text-sm font-semibold text-background-50"
          >
            <i className="ri-play-fill w-4 h-4 flex items-center justify-center text-sm" />
            开始吃瓜
          </a>
        </div>
      )}
    </header>
  );
}